export default [
  {
    path: 'M745.472 976H240c-114.688 0-207.744-93.056-207.744-207.744V262.784C32.256 148.096 125.312 55.04 240 55.04h505.472c114.688 0 207.744 93.056 207.744 207.744v505.472c0 114.688-93.056 207.744-207.744 207.744z',
    fill: '#00A9FA',
  },
  {
    path: 'M350.08 480.512c3.456-69.76 55.424-126.336 122.752-137.6-25.984-49.28-77.696-82.944-137.344-82.944-85.76 0-155.264 69.504-155.264 155.264 0 61.312 35.584 114.176 87.168 139.392 13.824-36.352 44.544-64.256 82.688-74.112z',
    fill: '#FFCA33',
  },
  {
    path: 'M665.6 438.528c-9.728 0-19.328 1.024-28.544 2.944-19.456-58.624-74.752-100.864-139.904-100.864-8.32 0-16.384 1.024-24.32 2.432 11.392 21.632 17.92 46.208 17.92 72.32 0 85.76-69.504 155.264-155.264 155.264-24.448 0-47.488-5.76-68.096-15.872-4.992 13.184-7.936 27.52-7.936 42.496 0 66.816 54.144 120.832 120.832 120.832H665.6c77.184 0 139.776-62.592 139.776-139.776S742.784 438.528 665.6 438.528z',
    fill: '#DBEEF7',
  },
  {
    path: 'M490.752 415.232c0-26.112-6.528-50.688-17.92-72.32-67.328 11.264-119.296 67.968-122.752 137.6-38.144 9.856-68.864 37.76-82.688 74.112 20.608 10.112 43.648 15.872 68.096 15.872 85.76 0 155.264-69.504 155.264-155.264z',
    fill: '#FFFAE1',
  },
]
